import '../App.css';
import Swal from 'sweetalert2';
import { useEffect, useState } from "react";
import { db } from '../firebase-config';
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

function InventarioProducts(){

    const [products, setProducts] = useState([]);
    const productsCollectionRef = collection(db, "products")
    
    const eliminarProducto = async (id) => {
        Swal.fire({
            title: 'Estas segura/o?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'No'
          }).then(async (result) => {
            if (result.isConfirmed) {
              Swal.fire(
                'Eliminado!',
                'Su articulo a sido eliminado.',
                'success'
                )
                const product = doc(db, "products", id)
                await deleteDoc(product)
                // setTimeout(() => window.location.reload(), 1500)
            }else if(result.dismiss){
                Swal.fire(
                    'Cancelado',
                    'Tu producto está a salvo :)',
                    'error'
                )
            }
        })
    }

    const getProducts = async()=>{
        const data = await getDocs(productsCollectionRef);
        setProducts(data.docs.map((doc)=>({...doc.data(), id: doc.id})))
    }

    useEffect(()=>{
    
        getProducts()
    
    },[])

    return (
        <>
            <div className="container-tablas-productos products-inventario">
                <section>
                <table>
                    <thead>
                        <tr className='encabezado'>
                            <th scope="col">#</th>
                            <th scope="col">Productos</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col"></th>
                            <th scope="col">Precio Unitario</th>
                            <th scope="col"></th>
                            <th scope="col">Total</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>

                        {products.map((p)=>{
                            return(
                                <tr>
                                    <td align='center'>
                                        <figure>
                                            <img className='td-img' src={p.image[0]} alt="" />
                                        </figure>
                                    </td>
                                    <td className='td-titulo'>{p.title}</td>
                                    <td className='td-cantidad-quanty'>
                                        <div class="input-group">
                                            <input type="text" name="quantity" value={p.quantity} min="1" max="100"/>
                                        </div>
                                    </td>
                                    <td></td>
                                    <td className='td-precio'>RD$ {p.price}.00</td>
                                    <td></td>
                                    <td>RD$ {p.quantity*p.price}.00</td>
                                    <td className='td-eliminar eli-ppp'>
                                        <article className='editar'>
                                            <i class="fa fa-edit"></i>
                                        </article>
                                        <article className="eliminar" onClick={()=>eliminarProducto(p.id)}>
                                            <i class="fa fa-window-close"></i>
                                        </article>
                                    </td>
                                </tr>
                            )
                        })}
                        
                    </tbody>
                </table>
                </section>
            </div>
        </>
    )
}

export default InventarioProducts
